export default __webpack_public_path__ + "bacd05001aa7216371e444934fa27d6d.png";